(function() {
  const details = document.querySelector('.product-details.sticky-content--desktop');
  if (!details) return;

  let lastScrollY = window.scrollY;
  let currentTop = 0;

  function update() {
    const scrollY = window.scrollY;
    const scrollDelta = scrollY - lastScrollY;
    const detailsHeight = details.offsetHeight;
    const viewportHeight = window.innerHeight;

    currentTop -= scrollDelta;

    const minTop = Math.min(0, viewportHeight - detailsHeight);
    const maxTop = 0;

    currentTop = Math.max(minTop, Math.min(maxTop, currentTop));
    details.style.top = currentTop + 'px';
    lastScrollY = scrollY;
  }

  window.addEventListener('scroll', update, { passive: true });
})();
